import React from 'react';
import Formsy from 'formsy-react';
import { Link } from 'react-router-dom';
import Radio from '../../form/Radio';
import withSplashMessage from '../../splashMessage/withSplashMessage';
import MailChimp from '../../../helpers/mailchimp';

class ServiceModal extends React.Component {
  state = {
    isSubmitted: false,
    contactType: 'PHONE'
  };

  render() {
    const { modal } = this.props;
    const { isOpen, isServiceable } = modal;
    const divStyle = {
      display: isOpen ? 'block' : 'none'
    };
    return (
      <div className="on-boarding__service-modal" style={divStyle}>
        <div className="cms__content cms__content--full">
          <p onClick={this.props.closeModal} className="cms__back-link a--blue">
            Back
          </p>

          {this.renderMaybe(isServiceable)}
          {this.renderNo(isServiceable)}
          {this.renderThanks(isServiceable)}
        </div>
      </div>
    );
  }

  // 07020 - maybe
  renderMaybe(isServiceable) {
    const divStyle = {
      display:
        isServiceable === 'maybe' && !this.state.isSubmitted ? 'block' : 'none'
    };

    const options = [
      { label: 'By Phone', value: 'PHONE' },
      { label: 'By Email', value: 'EMAIL' }
    ];

    return (
      <div className="maybe" style={divStyle}>
        <h1 className="on-boarding__h1">We'll be in touch.</h1>
        <p className="on-boarding__p">
          The Culinistas will reach out to you regarding your request within the
          next 48 hours.
        </p>

        <Formsy
          className="on-boarding__pref-contact"
          onValidSubmit={this.postMaybeSignup}
          onInvalidSubmit={this.handleInvalidSubmit}
        >
          <Radio
            className="radio--large radio--full-width radio--green"
            labelClassName="radio-label on-boarding__h3"
            name="contact_type"
            options={options}
            value={this.state.contactType}
            onChange={this.handleRadioChange}
            placeholder="How do you want us to contact you?"
            required
          />

          <input type="submit" className="btn btn--solid-blue" value="Submit" />
        </Formsy>
      </div>
    );
  }

  renderThanks(isServiceable) {
    const divStyle = {
      display:
        isServiceable === 'maybe' && this.state.isSubmitted ? 'block' : 'none'
    };
    return (
      <div className="thanks" style={divStyle}>
        <h1 className="on-boarding__h1">We’ll be in touch.</h1>
        <p className="on-boarding__p">
          The Culinistas will reach out to you regarding your request within the
          next 48 hours.
        </p>
        <p className="on-boarding__contact-type on-boarding__p on-boarding__p--bold">
          Great, we'll contact you by {this.state.contactType.toLowerCase()}.
        </p>
        <p className="a--blue" onClick={e => this.changeContact(e)}>
          Change Contact Method
        </p>
      </div>
    );
  }

  // 00000 - no
  renderNo(isServiceable) {
    const divStyle = {
      display: isServiceable === 'no' ? 'block' : 'none'
    };
    return (
      <div className="no" style={divStyle}>
        <h1 className="on-boarding__h1">Thank you for your interest.</h1>
        <div className="on-boarding__p">
          Unfortunately, we don’t have chefs in your neighborhood just yet.
          Please share your email so we can let you know when chefs become
          available in your area.
        </div>
        <div className="on-boarding-thank-you__cta">
          <button
            className="btn btn--solid-blue btn--full-mobile"
            onClick={this.joinMailingList}
          >
            Join our List
          </button>
          <Link to="/" className="btn btn--hollow-blue btn--full-mobile">
            Back To Homepage
          </Link>
        </div>
      </div>
    );
  }

  handleRadioChange = e => {
    this.setState({ contactType: e.target.value });
  };

  joinMailingList = () => {
    MailChimp.subscribe(this.props.client.email, 'SOFT_LAUNCH')
      .catch(error => console.log(error))
      .then(response => {
        this.props.addMessage({
          className: 'success',
          message: 'Thanks for joining the mailing list!'
        });
        this.props.closeModal();
      });
  };

  postMaybeSignup = email => {
    // TODO: Join the "????? List"
    fetch('https://hooks.zapier.com/hooks/catch/5491000/ob4n61d/', {
      mode: 'no-cors',
      method: 'POST',
      body: JSON.stringify({
        email_address: this.props.client.email,
        phone_number: this.props.client.phone_number,
        zip_code: this.props.client.zip_code,
        contact_type: this.state.contactType
      })
    })
      .catch(error => console.log(error))
      .then(response => {
        this.setState({ isSubmitted: true });
        this.props.addMessage({
          className: 'success',
          message: 'Thanks for joining the mailing list!'
        });
      });
  };

  changeContact = e => {
    e.preventDefault();
    this.setState({ isSubmitted: false });
  };
}

export default withSplashMessage(ServiceModal);



// WEBPACK FOOTER //
// ./src/components/onboarding/client/ServiceModal.js